module.exports = __webpack_public_path__ + "static/media/journeycare.59dd5da7.png";